/*
 * @Descripttion: 
 * @version: 
 * @Author: FuDi
 * @Date: 2024-02-27 09:38:46
 * @LastEditTime: 2024-02-27 09:50:52
 */
import _axios from './index'
import qs from 'qs'

// 列表
export const evidenceGet = (parameter) =>
    _axios({
        url: '/evidencePage',
        method: 'get',
        params: parameter,
        paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
        },
    })

// 立即取证
export const evidencePost = (data) =>
    _axios({
        url: '/evidencePage',
        method: 'post',
        data,
    })


// 详情
export const evidenceGetId = (params) =>
    _axios({
        url: `/evidencePage/${params}`,
        method: 'get',
    })


// 删除
export const evidenceDelete = (params) =>
    _axios({
        url: `/evidencePage/${params}`,
        method: 'delete',
    })


// 批量取证
export const evidenceExportImport = (data) =>
    _axios({
        url: `/evidencePage/batchImport`,
        method: 'post',
        data,
    })

// 重新取证
export const evidenceResume = (params) =>
    _axios({
        url: `/evidencePage/resume/${params}`,
        method: 'put',
    })


// 放弃取证、确认数据
export const evidencePut = (data) =>
    _axios({
        url: `/evidencePage`,
        method: 'put',
        data,
    })


// 单条确认数据
export const evidencePageConfirm = (data) =>
    _axios({
        url: `/evidencePage/confirm`,
        method: 'put',
        data,
    })

// 数据统计
export const evidencePageSum = () =>
    _axios({
        url: `/evidencePage/sum`,
        method: 'get',
    })

// 放弃
export const evidencePageCancel = (data) =>
    _axios({
        url: `/evidencePage/${data}`,
        method: 'put',
    })

// 重试
export const evidencePageResume = (data) =>
    _axios({
        url: `/evidencePage/resume/${data}`,
        method: 'put',
    })

// 用户信息
export const customerTsaCount = (data) =>
    _axios({
        url: `/customer/tsaCount`,
        method: 'get',
    })

// 用户信息
export const customerDetail = (data) =>
    _axios({
        url: `/customer/detail`,
        method: 'get',
    })
